var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"emoji-summary"},[_c('img',{class:_vm.classes,attrs:{"src":_vm.emoji.icon}}),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }